module.exports = __webpack_public_path__ + "static/media/DentalAccess.fa1ae811.mp4";